import { module } from 'modujs';

const CLASS = {
    OPEN: `is-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                button: 'toggleDropdown'
            }
        }
    }

    toggleDropdown(e) {
        const target = e.curTarget;
        const container = this.parent('container', target);

        if (container.classList.contains(CLASS.OPEN)) {
            container.classList.remove(CLASS.OPEN);
        } else {
            container.classList.add(CLASS.OPEN);
        }
    }
}
